const $ = jQuery.noConflict();

function scrollFunc(e) {
	const body = $('body');
	const header = document
		.querySelector('.main-header')
		.getBoundingClientRect().height;
	const inpageNav = $('.block-hero__links');
	let target = false;

	if (e) {
		e.preventDefault();
		const trigger = $(e.currentTarget);
		target =
			trigger.attr('href') === '#next'
				? trigger.parents('section').next()
				: $(trigger.attr('href'));
	} else {
		const id = window.location.hash;
		if (id) {
			target = $(id);
		}
	}

	if (target.length) {
		let offset = header; // header height

		offset += inpageNav.length ? inpageNav.outerHeight() : 0;

		let mt = 0;
		let pt = 0;

		if (target.hasClass('section-wrapper')) {
			mt = parseInt(target.children().first().css('margin-top'), 10);
			pt = parseInt(target.children().first().css('padding-top'), 10);
		} else {
			mt = parseInt(target.css('margin-top'), 10);
			pt = parseInt(target.css('padding-top'), 10);
		}

		offset += mt > 0 && pt === 0 ? mt : 0;

		body.addClass('smooth-scroll');
		$('html, body')
			.stop()
			.animate(
				{
					scrollTop: parseInt(target.offset().top - offset, 10),
				},
				600,
				() => {
					setTimeout(() => {
						body.removeClass('smooth-scroll');
					}, 100);
				}
			);
	}
}

/**
 * Prevent automatic scrolling of page to anchor by browser after loading of page.
 * Do not call this function in $(...) or $(window).on('load', ...),
 * it should be called earlier, as soon as possible.
 */
function preventAnchorScroll() {
	if (window.location.hash) {
		window.scrollTo(0, 0);
	}
	setTimeout(scrollFunc, 100);
}

function smoothScroll() {
	$(document).on('click', 'a[href^="#"]:not([href="#"])', scrollFunc);
	// setTimeout(scrollFunc, 100);
	preventAnchorScroll();
}

export default smoothScroll;
